import { useRandomCreateAccountBackgroundImage } from "@/Helpers/randomBackgroundImage";
import { useOnce } from "@/Hooks/useOnce";
import useQuery from "@/Hooks/useQuery";
import { useNavigate } from "react-router-dom";
import { AuthenticationCreateAccount } from "@/Shared/Authentication/CustomComponents/AuthenticationCreateAccount";
import { AuthenticationScreenContainer } from "./CustomComponents/AuthenticationScreenContainer";
import { useUsersApi2 } from "@/Hooks/useUsersApi2";

export function CreateAccountScreen() {
  const navigate = useNavigate();
  const query = useQuery();
  const usersApi = useUsersApi2();

  // query-string parses each param as string | string[] | null; the prefill
  // link always carries single values, so narrow each to a non-empty string.
  const emailParam = query["email"];
  const nameParam = query["name"];
  const codeParam = query["code"];
  const prefilledEmail =
    typeof emailParam === "string" && emailParam !== ""
      ? emailParam
      : undefined;
  const prefilledName =
    typeof nameParam === "string" && nameParam !== "" ? nameParam : undefined;
  const prefilledCode =
    typeof codeParam === "string" && codeParam !== "" ? codeParam : undefined;

  const backgroundImage = useRandomCreateAccountBackgroundImage();

  useOnce(async function () {
    if (prefilledEmail !== undefined && prefilledName !== undefined) {
      try {
        usersApi.postUsersSharePrefilledInfo({
          email: prefilledEmail,
          name: prefilledName,
        });
      } catch (e) {
        console.error(`Error with postUsersSharePrefilledInfo`, { e });
      }
    }
  });

  return (
    <AuthenticationScreenContainer imageUrl={backgroundImage}>
      <AuthenticationCreateAccount
        onSignInInstead={() => navigate("/sign-in")}
        onSuccess={() => navigate("/")}
        prefilledName={prefilledName}
        prefilledCode={prefilledCode}
        prefilledEmail={prefilledEmail}
      />
    </AuthenticationScreenContainer>
  );
}
